import { ArrowUpRight, ArrowRight } from "lucide-react";

const WHATSAPP =
    "https://wa.me/919739191933?text=Hi%20Pixelgrok%20Media%2C%20I%27d%20like%20to%20book%20a%20discovery%20call.";
const MAILTO =
    "mailto:contact@pixelgrok.com?subject=Discovery%20Call%20%E2%80%94%20Pixelgrok%20Media";

export default function Nav() {
    const links = [
        { href: "#ecosystem", label: "Ecosystem" },
        { href: "#services", label: "Services" },
        { href: "#geo", label: "GEO" },
        { href: "#process", label: "Process" },
        { href: "#why", label: "Why us" },
    ];
    return (
        <header
            data-testid="site-nav"
            className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#050505]/85 border-b border-[#26262a]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-24 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="logo-home"
                    aria-label="Pixelgrok Media"
                    className="flex items-center group"
                >
                    <img
                        src="/pixelgrok-logo.png"
                        alt="Pixelgrok Media"
                        className="h-14 md:h-16 w-auto select-none"
                        draggable="false"
                        width="430"
                        height="160"
                    />
                </a>

                <nav className="hidden md:flex items-center gap-9 text-[13px] uppercase tracking-[0.18em] text-[#a0a0ab]">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-${l.label.toLowerCase()}`}
                            className="red-link hover:text-white transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href={WHATSAPP}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="nav-cta-discovery-call"
                    className="group inline-flex items-center gap-2 bg-[#e6192b] hover:bg-[#ff2a3d] text-white px-4 md:px-5 py-2.5 rounded-full text-[12px] uppercase tracking-[0.2em] font-medium transition-all hover:scale-[1.02]"
                >
                    Book a Call
                    <ArrowUpRight
                        size={14}
                        className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                </a>
            </div>
        </header>
    );
}

export { MAILTO, WHATSAPP };
